interface AdHocCheckInput {
    fsCustomerID?: string | null;
    fsEmployerID?: string | null;
}

export function getAdHocValidationMessage(checkInPackage?: AdHocCheckInput | null): string | undefined {
    if (!checkInPackage) return undefined;

    const missingFields = [
        !checkInPackage.fsCustomerID?.trim() && 'Customer',
        !checkInPackage.fsEmployerID?.trim() && 'Employer',
    ].filter(Boolean);

    return missingFields.length
        ? `Select ${missingFields.join(' and ')} before a compliance check can be generated.`
        : undefined;
}
